<template>
  <div class="app-container">
    <el-tabs v-model="orderType"> <!-- h -->
      <el-tab-pane label="未下达" name="未下达">
      </el-tab-pane>
      <el-tab-pane label="已下达" name="已下达">
      </el-tab-pane>
      <!-- <el-tab-pane label="日生产" name="日生产">
      </el-tab-pane> -->

      <!-- h -->
      <!-- <el-tabs v-model="tabName" tab-position="top" >
        <el-tab-pane label="注塑工单" name="tab1">
          <wj-currency :Stage="Stage" :StageName="StageName" :OrderType="orderType"></wj-currency>
        </el-tab-pane>
      </el-tabs> -->
      <wj-currency :Stage="Stage" :StageName="StageName" :OrderType="orderType"></wj-currency>
      <!-- h -->

    </el-tabs>
    
  </div>
</template>
<script>
import wjCurrency from "./currency";

export default {
  name: "injection",
  components: { wjCurrency},
  data() {
    return {
      tabName: 'tab1',
      orderType:'未下达', //是否下达标签
      Stage:0,
      StageName:'注塑'
    };
  },
  created(){
  },
  mounted(){
  },
  activated(){
  },
  methods: {
  },
 
};
</script>

<style lang="scss" scoped>
.count {
  margin-right: 15px;
  font-size: 14px;
  color: red;
  display: inline-block;
}
</style>